import React, { useState, useEffect } from "react";
import Col from "../../UIcomponent/Column";
import { SideMenuItemList } from "./SideMenuItemList";
import "./SideMenu.scss";
import StyledLink from "../../UIcomponent/Link";
import Image from "../../UIcomponent/Image";
import LocalConfig from "../../Utility/Method/LocalConfig";
import LocalToken from "../../Utility/Method/LocalToken";
import logout from "../../Assets/icon/logout.svg";
import StyledButton from "../../UIcomponent/Button";
import login from "../../Assets/icon/login.svg";
import signUp from "../../Assets/icon/signUp.svg";
import Cookies from "js-cookie";
const SideMenu = React.forwardRef((props, ref) => {
  const {
    pathname,
    teacherRoute,
    isLoggedin,
    role,
    visible,
    lang,
    onClick,
    loginRegisterHanlder,
    teacherRegisterHandler,
  } = props;
  const [sideMenuList, setSideMenuList] = useState(SideMenuItemList(pathname));
  const SubClick = (KEY, value) => {
    let newMenuItems = [...sideMenuList];
    newMenuItems = newMenuItems.map((each, i) => {
      return {
        ...each,
        toggle: KEY === each.key ? (value === true ? false : true) : false,
      };
    });
    setSideMenuList(newMenuItems);
  };
  useEffect(() => {}, [sideMenuList]);
  const Logout = () => {
    LocalConfig.Remove();
    LocalToken.Remove();
    Cookies.remove("LINGO_ACCESS_TOKEN");
    Cookies.remove("LINGO_REFRESH_TOKEN");
    if (pathname.includes("find-teachers/")) {
      return window.location.reload();
    }
    pathname !== "/find-teachers"
      ? window.location.replace("/")
      : window.location.reload();
  };
  return (
    <Col
      className={`c__Sidemenu ${visible === true && "c__Sidemenu--Show"}`}
      innerRef={ref}
      style={{
        borderRadius:
          (pathname === "/" || pathname === teacherRoute) && "0px 10px 0px 0px",
      }}
    >
      <Col xl={24} lg={24} md={24} sm={24} xs={24} className="o__Sidemenu">
        {/* <StyledLink
                    to="/teachers-list"
                    xl={22}
                    lg={22}
                    md={22}
                    sm={22}
                    xs={22}
                    className="o__Sidemenu__Item--RES"
                    key={1}
                    onClick={() => {
                        ref.current.classList.remove("c__Sidemenu--Show");
                    }}
                >
                    <Image src={list} width={20} height={20} />

              لیست اساتید
            </StyledLink>
                {
                    isLoggedin === true &&
                    <StyledLink
                        to="/dashboard"
                        xl={22}
                        lg={22}
                        md={22}
                        sm={22}
                        xs={22}
                        className="o__Sidemenu__Item--RES"
                        key={2}
                        onClick={() => {
                            ref.current.classList.remove("c__Sidemenu--Show");
                            document.body.style.overflowY = 'auto'
                        }}
                    >
                        <Image src={dashboard} width={20} height={20} />

              داشبورد
            </StyledLink>
                }
                {
                    isLoggedin === true &&
                    <StyledLink
                        to="/dashboard/lessons"
                        xl={22}
                        lg={22}
                        md={22}
                        sm={22}
                        xs={22}
                        className="o__Sidemenu__Item--RES"
                        key={3}
                        onClick={() => {
                            ref.current.classList.remove("c__Sidemenu--Show");
                            document.body.style.overflowY = 'auto'
                        }}
                    >
                        <Image src={classes} width={20} height={20} />

              کلاس ها
            </StyledLink>
                } */}
        {sideMenuList.map((menu) => {
          return (
            <>
              {menu.hasSubCategory === false ? (
                <StyledLink
                  style={{
                    display:
                      menu.needLoggedIn === true && !menu.roles.includes(role)
                        ? "none"
                        : menu.screenMaxSize < window.innerWidth
                        ? "none"
                        : "flex",
                  }}
                  // key={"/profile" + menu.path}
                  to={menu.absloutePath + menu.path}
                  onClick={() => {
                    onClick();
                  }}
                  force={menu.path === "/find-teachers"}
                  // onCancel={() => history.push(menu.path)}
                  className="o__Sidemenu__Item"
                >
                  <Image src={menu.icon} width={20} height={20} />
                  {menu.title[`${lang}`]}
                </StyledLink>
              ) : (
                <Col
                  className="o__Sidemenu__Item"
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: menu.toggle === true && "15px 0px 0px 15px",
                    display:
                      menu.needLoggedIn === true && !menu.roles.includes(role)
                        ? "none"
                        : menu.screenMaxSize < window.innerWidth
                        ? "none"
                        : "flex",
                  }}
                >
                  <Col
                    style={{
                      width: "100%",
                      // height: 'auto',
                      justifyContent: "flex-start",
                    }}
                    onClick={() => SubClick(menu.key, menu.toggle)}
                  >
                    <Image src={menu.icon} width={20} height={20} />
                    {menu.title[`${lang}`]}
                  </Col>
                  <Col
                    className={`c__Sidemenu__Submenu ${
                      menu.toggle === true ? "subExpand" : "subCollapse"
                    }`}
                  >
                    {menu.toggle === true &&
                      menu.subCategories.map((sub) => {
                        return (
                          <StyledLink
                            key={menu.key}
                            style={{
                              display:
                                menu.needLoggedIn === true &&
                                !menu.roles.includes(role)
                                  ? "none"
                                  : menu.screenMaxSize < window.innerWidth
                                  ? "none"
                                  : "flex",
                            }}
                            className="o__Sidemenu__SubMenu"
                            onClick={() => {
                              onClick();
                            }}
                            to={`${sub.absloutePath}`}
                          >
                            <Col
                              // xl={24} lg={24} md={6} sm={6} xs={12}
                              className="o__Sidemenu__SubMenu__Item"
                              // onClick={() => SubClick(menu.key, menu.toggle)}
                              // style={{
                              //     borderBottom: index !== State.menuItems.length - 1 && '1px solid #e0e0e0'
                              // }}
                            >
                              {sub.name}
                            </Col>
                          </StyledLink>
                        );
                      })}
                  </Col>
                </Col>
              )}
            </>
          );
        })}
        {isLoggedin === true && (
          <Col
            xl={22}
            lg={22}
            md={22}
            sm={22}
            xs={22}
            className="o__Sidemenu__Item--Exit"
            onClick={Logout}
          >
            <Image src={logout} width={20} height={20} />
            خروج
          </Col>
        )}
        {isLoggedin === false && (
          <Col
            xl={22}
            lg={22}
            md={22}
            sm={22}
            xs={22}
            className="o__Sidemenu__Item--RES"
            onClick={() => {
              onClick();
              loginRegisterHanlder("login");
            }}
          >
            <Image src={login} width={20} height={20} />
            ورود
          </Col>
        )}
        {isLoggedin === false && (
          <Col
            xl={22}
            lg={22}
            md={22}
            sm={22}
            xs={22}
            className="o__Sidemenu__Item--RES"
            onClick={() => {
              onClick();
              loginRegisterHanlder("register");
            }}
          >
            <Image src={signUp} width={20} height={20} />
            ثبت نام
          </Col>
        )}
        {isLoggedin === false && (
          <Col
            xl={22}
            lg={22}
            md={22}
            sm={22}
            xs={22}
            className="o__Sidemenu__Item--RES  c__Sidemenu__Item--TeacherRegisterButton"
          >
            <StyledButton
              default
              onClick={() => {
                onClick();
                teacherRegisterHandler();
              }}
            >
              ثبت نام استاد
            </StyledButton>
          </Col>
        )}
      </Col>
    </Col>
  );
});

export default SideMenu;
